const useCurrentUser = () => {
  const appState = JSON.parse(localStorage.getItem('appState'));
  const user = appState?.user;
  const loginEmail = localStorage.getItem('loginEmail');

  return {
    user,
    role: user?.role,
    isAdmin: user?.role === 'admin',
    loginEmail,
  };
};

export default useCurrentUser;
